import { currentHomeIdState } from '@/state/home.state';
import { EquipmentDao } from '@rock/db-admin';
import type { ModelId, SpaceId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const dao = new EquipmentDao();

// One home-level subscription; per-space views derive by filtering on the `spaceId` field.
export const allHomeEquipmentState = dao.equipmentListAtom(currentHomeIdState);

export const homeEquipmentListState = atomFamily(
    (spaceId: SpaceId) =>
        atom(async (get) => {
            const all = await get(allHomeEquipmentState);
            return all.filter((e) => e.spaceId === spaceId);
        }),
    shallowEqual,
);

/** Up to 10 equipment instances resolved to this model, across every home — the model page's Equipment tab. */
export const equipmentForModelState = atomFamily(
    (modelId: ModelId | undefined) => dao.equipmentForModelAtom(modelId),
    shallowEqual,
);

/** True total count of equipment resolved to this model (server aggregation) — the Equipment tab badge. */
export const equipmentCountForModelState = atomFamily(
    (modelId: ModelId | undefined) => atom(async () => (modelId ? dao.countEquipmentForModel(modelId) : 0)),
    shallowEqual,
);

/** Total equipment docs across all homes (server aggregation, one-shot) — the Dashboard's Equipment stat. */
export const equipmentTotalCountState = atom(async () => dao.countAllEquipment());

/** Equipment count in one space across all homes (server aggregation, one-shot) — Dashboard's per-space card. */
export const equipmentCountForSpaceState = atomFamily(
    (spaceId: SpaceId) => atom(async () => dao.countEquipmentForSpace(spaceId)),
    shallowEqual,
);
